import {
    GET_DELIVERY_MANAGEMENT,
    DELIVERY_LOADING,
    ASSIGN_DELIVERY_AGENT,
    UPDATE_DELIVERY_STATUS,
    DELIVERY_ERROR,
    GET_DELIVERY_AGENTS
} from '../actions/types';

const initialState = {
    loading: false,
    error: null,
    pendingDelivery: [],
    assignedDelivery: [],
    inProgressDelivery: [],
    scheduledDelivery: [],
    deliveredDelivery: [],
    cancelledDelivery: [],
    failedDelivery: [],
    counts: {},
    total: 0,
    pages: 0,
    agents: {
        freeAgents: [],
        busyAgents: [],
        refillAgents: [],
        lowInventoryAgents: []
    }
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DELIVERY_LOADING:
            return {
                ...state,
                loading: true
            };
        
        case GET_DELIVERY_MANAGEMENT:
            return {
                ...state,
                loading: false,
                error: null,
                pendingDelivery: payload.deliveries.pending || [],
                assignedDelivery: payload.deliveries.assigned || [],
                inProgressDelivery: payload.deliveries.inProgress || [],
                scheduledDelivery: payload.deliveries.scheduled || [],
                deliveredDelivery: payload.deliveries.delivered || [],
                cancelledDelivery: payload.deliveries.cancelled || [],
                failedDelivery: payload.deliveries.failed || [],
                counts: payload.counts || {},
                total: payload.total || 0,
                pages: payload.pages || 0
            };
        
        case GET_DELIVERY_AGENTS:
            return {
                ...state,
                agents: payload
            };
        
        case ASSIGN_DELIVERY_AGENT:
            // Remove the delivery from pending and add to assigned
            return {
                ...state,
                pendingDelivery: state.pendingDelivery.filter(
                    delivery => delivery._id !== payload.deliveryId
                ),
                assignedDelivery: [...state.assignedDelivery, payload.updatedDelivery]
            };
        
        case UPDATE_DELIVERY_STATUS:
            // Handle status update based on the new status
            const updatedDelivery = payload.updatedDelivery;
            const deliveryId = payload.deliveryId;
            
            // Helper function to filter out the updated delivery
            const filterOutDelivery = deliveries => 
                deliveries.filter(delivery => delivery._id !== deliveryId);
            
            // Determine which arrays need to be updated based on status
            switch (updatedDelivery.status) {
                case 'in-progress':
                    return {
                        ...state,
                        assignedDelivery: filterOutDelivery(state.assignedDelivery),
                        inProgressDelivery: [...state.inProgressDelivery, updatedDelivery]
                    };
                
                case 'delivered':
                    return {
                        ...state,
                        inProgressDelivery: filterOutDelivery(state.inProgressDelivery),
                        deliveredDelivery: [...state.deliveredDelivery, updatedDelivery]
                    };
                
                case 'cancelled':
                    // Could be cancelled from any status
                    return {
                        ...state,
                        pendingDelivery: filterOutDelivery(state.pendingDelivery),
                        assignedDelivery: filterOutDelivery(state.assignedDelivery),
                        inProgressDelivery: filterOutDelivery(state.inProgressDelivery),
                        cancelledDelivery: [...state.cancelledDelivery, updatedDelivery]
                    };
                
                case 'failed':
                    // Could be failed from assigned or in-progress
                    return {
                        ...state,
                        assignedDelivery: filterOutDelivery(state.assignedDelivery),
                        inProgressDelivery: filterOutDelivery(state.inProgressDelivery),
                        failedDelivery: [...state.failedDelivery, updatedDelivery]
                    };
                
                default:
                    return state;
            }
        
        case DELIVERY_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        
        default:
            return state;
    }
}